(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/history-suspensions.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/components/history-suspensions.js');
'use strict';

const {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody
} = svs.ui.reactTable;
const {
  HistorySuspension
} = svs.spelpaus.pages.svsSuspension.components;
const HistorySuspensions = () => {
  const historySuspensions = ReactRedux.useSelector(state => state.suspension.historySuspensions || []);
  const hasSuspension = historySuspensions && historySuspensions.length > 0;
  if (!hasSuspension) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "h3 align-center"
  }, "Din spelpaushistorik"), React.createElement("div", {
    className: "align-left"
  }, "Nedan ser du avslutade spelpauser"), React.createElement(Table, {
    bordered: false,
    className: "margin-v-1"
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, null, React.createElement("span", {
    className: "f-bold"
  }, "Spel")), React.createElement(TableHeader, null, React.createElement("span", {
    className: "f-bold"
  }, "L\xE4ngd")), React.createElement(TableHeader, {
    className: "right"
  }, React.createElement("span", {
    className: "f-bold"
  }, "Datum")))), React.createElement(TableBody, null, historySuspensions && historySuspensions.length > 0 && historySuspensions.map(s => React.createElement(HistorySuspension, {
    key: s.requested,
    suspension: s
  })))));
};
svs.spelpaus.pages.svsSuspension.components.HistorySuspensions = HistorySuspensions;

 })(window);